module.exports = __webpack_public_path__ + "static/fonts/Mont-BoldItalic.b3309b4.ttf";